module.exports = __webpack_public_path__ + "static/media/question.042c5fba.svg";